<template lang="pug">
  div(:class="['guide-item', { 'guide-item--left': left }]")
    div(class="d-flex align-center justify-space-between")
      div(class="guide-item__text")
        span(class="guide-item__text-arrow") ←
        | {{ $t('Fill') }}
      div(class="guide-item__counter") {{ step }} / {{ stepsCount }}
    button(
      v-if="false"
      class="guide-item__btn"
      :class="{ disabled: disabledNext }"
      :disabled="disabledNext"
      @click="$emit('next')"
    ) {{ buttonText }}
</template>

<script>
export default {
  name: 'EGuideItem',
  props: {
    step: {
      type: Number,
      default: 0
    },
    stepsCount: {
      type: Number,
      default: 0
    },
    isLastStep: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    },
    left: { type: Boolean, default: false }
  },
  computed: {
    buttonText() {
      return this.isLastStep ? this.$t('Finish') : this.$t('Next')
    }
  }
}
</script>

<style scoped lang="scss">
.guide-item {
  background: $text-dark;
  border-radius: 12px;

  width: 200px;
  padding: 12px;

  position: absolute;
  right: -220px;
  top: 50%;
  z-index: map-get($zIndexes, 'underFixed');
  transform: translateY(-50%);

  @media (max-width: map-get($breakpoints, 'sm')) {
    width: 60px;
    right: -70px;
    padding: 4px;
    border-radius: 6px;
    top: 50%;
  }

  &:before {
    content: '';
    width: 16px;
    height: 16px;

    position: absolute;
    left: -5px;
    top: 50%;
    transform: translateY(-50%) rotateZ(45deg);
    z-index: map-get($zIndexes, 'middle');

    background: $text-dark;

    @media (max-width: map-get($breakpoints, 'sm')) {
      left: -3px;
      width: 8px;
      height: 8px;
    }
  }

  &__text {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: $white;

    @media (max-width: map-get($breakpoints, 'sm')) {
      font-size: 8px;
      padding-left: 5px;
      line-height: 7px;
    }

    &-arrow {
      font-size: 20px;
      padding-right: 8px;

      @media (max-width: map-get($breakpoints, 'sm')) {
        display: none;
      }
    }
  }

  &__counter {
    color: rgba(255, 255, 255, 0.64);
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;

    @media (max-width: map-get($breakpoints, 'sm')) {
      display: none;
    }
  }

  &__btn {
    min-width: 80px;
    height: 40px;

    border-radius: 12px;
    background: $white;
    padding: 0 16px;

    color: #000;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;

    &.disabled {
      opacity: 0.6;
    }
  }

  &--left {
    left: -220px !important;
    right: auto !important;

    &:before {
      right: -5px;
      left: auto;
    }

    @media (max-width: map-get($breakpoints, 'sm')) {
      left: -70px !important;
      right: auto !important;

      &:before {
        right: -3px;
        left: auto;
      }
    }
  }
}
</style>
